module.exports = __webpack_public_path__ + "img/contactItem3.e4df6894.png";